export const messages = {
  en: {
    adminServ: {
      queryCondition: 'Query Conditions',
      inputServName: 'Please input service name',
      selectServiceType: 'Please select service type',
      query: 'Query',
      onShelvesService: 'On Shelves Service',
      shop: 'Shop',
      serviceNumber: 'Service Number',
      serviceName: 'Service Name',
      serviceType: 'Service Type',
      dispatchMethod: 'Dispatch Method',
      grabOrder: 'Grab Order',
      assign: 'Assign',
      roundRobin: 'Round Robin',
      returnVisitMethod: 'Return Visit Method',
      noReturnVisit: 'No Return Visit',
      noReturnVisitAfterComment: 'No Return Visit After Comment',
      allReturnVisit: 'All Return Visit',
      salesVolume: 'Sales Volume',
      defaultFee: 'Default Fee',
      sort: 'Sort',
      shelvesStatus: 'Shelves Status',
      notOnShelves: 'Not On Shelves',
      onShelves: 'On Shelves',
      shelvesTime: 'Shelves Time',
      operation: 'Operation',
      view: 'View',
      delete: 'Delete',
      scanToViewService: 'Scan to view service'
    }
  },
  zh: {
    adminServ: {
      queryCondition: '查询条件',
      inputServName: '请输入服务名称',
      selectServiceType: '请选择服务类型',
      query: '查询',
      onShelvesService: '上架服务',
      shop: '店铺',
      serviceNumber: '服务编号',
      serviceName: '服务名称',
      serviceType: '服务类型',
      dispatchMethod: '派单方式',
      grabOrder: '抢单',
      assign: '指派',
      roundRobin: '轮训',
      returnVisitMethod: '回访方式',
      noReturnVisit: '都不回访',
      noReturnVisitAfterComment: '已评价不回访',
      allReturnVisit: '都回访',
      salesVolume: '销量',
      defaultFee: '默认费用',
      sort: '排序',
      shelvesStatus: '上架状态',
      notOnShelves: '未上架',
      onShelves: '上架',
      shelvesTime: '上架时间',
      operation: '操作',
      view: '查看',
      delete: '删除',
      scanToViewService: '手机扫码查看家政服务'
    }
  }
}